import { render, staticRenderFns } from "./ChooseUs.vue?vue&type=template&id=5b3ffc79&"
import script from "./ChooseUs.vue?vue&type=script&lang=js&"
export * from "./ChooseUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports